
import { motion } from 'framer-motion';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const GalleryPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero Section */}
      <section className="pt-32 pb-20 bg-[#F8F6F3]">
        <div className="max-w-4xl mx-auto px-6 lg:px-12 text-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <h1 className="font-serif text-6xl text-[#2C2C2C] mb-6">
              Video Gallery
            </h1>
            <div className="flex items-center justify-center mb-6">
              <div className="h-0.5 w-32 bg-[#C9A961]"></div>
            </div>
            <p className="text-xl text-[#666666] leading-relaxed">
              Explore behind-the-scenes content, author readings, writing workshops,<br />
              and insights into the creative process
            </p>
          </motion.div>
        </div>
      </section>

      {/* Featured Video Section */}
      <section className="py-20 bg-white">
        <div className="max-w-5xl mx-auto px-6 lg:px-12">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="text-center mb-12"
          >
            <span className="text-sm tracking-widest text-[#C9A961] uppercase">
              Featured Content
            </span>
            <h2 className="font-serif text-5xl text-[#2C2C2C] mt-4 mb-6">
              Latest Video
            </h2>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            viewport={{ once: true }}
            className="bg-white rounded-2xl overflow-hidden shadow-2xl"
          >
            <div className="relative w-full h-96 lg:h-[600px] overflow-hidden">
              <div className="w-full h-full bg-gray-200 flex items-center justify-center">
                <iframe
                  className="w-full h-full"
                  src="https://www.youtube.com/embed/w4tfxmgjFYg"
                  title="Family Secrets: A San Francisco Saga"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              </div>
            </div>
            <div className="p-8 lg:p-12">
              <div className="flex items-center justify-center text-sm text-[#C9A961] mb-4">
                <i className="ri-calendar-line mr-2"></i>
                <span>March 2024</span>
              </div>
              <h3 className="font-serif text-4xl text-[#2C2C2C] mb-4 text-center">
                Family Secrets: A San Francisco Saga
              </h3>
              <p className="text-lg text-[#666666] leading-relaxed text-center max-w-3xl mx-auto">
                Join me for an intimate look at the writing process and inspiration behind 
                Family Secrets: A San Francisco Saga. In this video, I share the research, 
                personal experiences, and creative decisions that shaped this multi-generational 
                story set against the backdrop of San Francisco's rich history.
              </p>
            </div>
          </motion.div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-[#F8F6F3]">
        <div className="max-w-4xl mx-auto px-6 lg:px-12 text-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            <h2 className="font-serif text-4xl text-[#2C2C2C] mb-6">
              Stay Updated
            </h2>
            <p className="text-lg text-[#666666] mb-8">
              Subscribe to be notified when new videos are published
            </p>
            <a
              href="/contact"
              className="inline-block px-10 py-4 bg-[#8B2635] text-white rounded-lg hover:bg-[#6d1e29] transition-all shadow-md text-lg font-medium whitespace-nowrap cursor-pointer"
            >
              Subscribe to Newsletter
            </a>
          </motion.div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default GalleryPage;
